module.exports = __webpack_public_path__ + "media/images/official/about_comipla_kv-91db52365c4fe704375ed550b0f8057a.svg";